import { api } from './api';

export interface ApiNote {
  id: string;
  entityType: string;
  entityId: string;
  caseId: string | null;
  body: string;
  isPrivate: boolean;
  createdAt: string;
  updatedAt: string;
  author: { id: string; firstName: string; lastName: string; memberType: string } | null;
  case: { id: string; caseNumber: string; caseName: string } | null;
}

export interface ListNotesQuery {
  caseId?: string;
  entityType?: string;
  entityId?: string;
  page?: number;
  limit?: number;
  sortOrder?: 'asc' | 'desc';
}

export interface ListNotesResponse {
  notes: ApiNote[];
  pagination: { page: number; limit: number; total: number; totalPages: number };
}

export async function fetchNotes(query: ListNotesQuery = {}): Promise<ListNotesResponse> {
  const res = await api.get('/notes', {
    params: { limit: 100, sortBy: 'createdAt', sortOrder: 'desc', ...query },
  });
  const payload = (res.data as { data?: ListNotesResponse }).data ?? (res.data as ListNotesResponse);
  return payload;
}

export interface CreateNotePayload {
  entityType: string;
  entityId: string;
  caseId?: string;
  body: string;
  isPrivate?: boolean;
}

export async function createNote(payload: CreateNotePayload): Promise<ApiNote> {
  const res = await api.post('/notes', payload);
  const data = (res.data as { data?: ApiNote }).data ?? (res.data as ApiNote);
  return data;
}

export async function deleteNote(id: string): Promise<void> {
  await api.delete(`/notes/${id}`);
}

/** PATCH /notes/:id — the server allows only the note's author, on a matter they can still access. */
export async function updateNote(id: string, input: { body: string }): Promise<ApiNote> {
  const res = await api.patch(`/notes/${id}`, input);
  return (res.data as { data?: ApiNote }).data ?? (res.data as ApiNote);
}

export function authorName(n: ApiNote): string {
  if (!n.author) return 'Unknown';
  const rankSuffix = n.author.memberType === 'silk' ? ' KC' : '';
  return `${n.author.firstName} ${n.author.lastName}${rankSuffix}`;
}
